export default __webpack_public_path__ + "static/azulesPorUnDia-a9d387bee6e8f3a314186fb47cd91e40.png";